// extracted by mini-css-extract-plugin
export default {"container":"MediaStep_container__t5Y+C","header":"MediaStep_header__SjVjw","icon":"MediaStep_icon__G3uvi","content":"MediaStep_content__xDmUU"};